module.exports = __webpack_public_path__ + "img/chinaLife.55d1d5f8.png";